import { jsx as g } from "react/jsx-runtime";
import T from "clsx";
import { useState as l, useRef as y, useEffect as v } from "react";
import "js-cookie";
import { useResizeObserver as E } from "../../hooks/useResizeObserver.js";
import '../../_assets/Collapse.DXHbNkk9.css';const b = "_collapse_1k22r_1", D = "_isCollapsed_1k22r_5", _ = {
  collapse: b,
  isCollapsed: D
}, r = "cubic-bezier(0.19, 1, 0.2, 1)", $ = (c, a) => {
  const t = Math.max(0, a), o = t / 2;
  if (c)
    return `
      height ${t}ms ${r},
      opacity ${t}ms ${r}
    `;
  const i = o;
  return `
    height ${i}ms ${r},
    opacity ${i}ms ${r}
  `;
}, w = ({
  className: c,
  children: a,
  isOpened: t,
  openDurationMs: o = 500,
  ariaOverride: i
}) => {
  const [e, R] = l(t), f = y(null), n = y(null), [h, x] = l(null), [d, m] = l(e ? "auto" : "0px"), [C, p] = l(e);
  return v(() => {
    if (t === e || h === null)
      return;
    R(t), p(!1);
    let s = `${h}px`;
    n.current.style.transition = $(t, o), n.current.style.height = s, t || (n.current.offsetWidth, s = "0px", n.current.style.height = s), m(s);
  }, [h, t]), E({
    ref: f,
    onResize: (s) => {
      const u = s[0];
      u && u.contentRect.height > 0 && x(u.contentRect.height);
    }
  }), /* @__PURE__ */ g(
    "div",
    {
      ref: n,
      className: T(c, _.collapse, !e && _.isCollapsed),
      style: {
        height: d,
        overflow: d === "auto" ? "visible" : "hidden",
        transition: $(e, o)
      },
      "aria-hidden": i !== void 0 ? i : !e,
      onTransitionEnd: () => {
        e && !C && (m("auto"), p(!0));
      },
      children: /* @__PURE__ */ g(
        "div",
        {
          ref: f,
          ...e ? {} : {
            // Prevent interaction with any child elements when collapsed.
            // This should prevent tab focus as well.
            inert: !0
          },
          children: a
        }
      )
    }
  );
};
export {
  w as Collapse
};
